import { Typography } from '@mui/material';
import React from 'react';

export const OrderedList = ({ children }: { children: React.ReactNode }) => {
  return <ol>{children}</ol>;
};

export const UnorderedList = ({
  listStyleType = 'circle',
  children,
}: {
  listStyleType?: string;
  children: React.ReactNode;
}) => {
  return <ul style={{ listStyleType: listStyleType }}>{children}</ul>;
};

export const CustomListItem = ({ children }: { children: React.ReactNode }) => {
  return (
    <li>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {children}
      </Typography>
    </li>
  );
};
